module.exports = __webpack_public_path__ + "static/img/gg1.5f99875c.jpg";